var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYouTube = function SvgYouTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 15.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E5E5E5",
    rx: 15.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#YouTube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M26.54 11.342a2.72 2.72 0 0 0-1.945-1.894C22.88 9 16 9 16 9s-6.88 0-8.595.448a2.72 2.72 0 0 0-1.945 1.894C5 13.012 5 16.5 5 16.5s0 3.487.46 5.158a2.72 2.72 0 0 0 1.945 1.894C9.12 24 16 24 16 24s6.88 0 8.595-.448a2.72 2.72 0 0 0 1.945-1.894C27 19.988 27 16.5 27 16.5s-.002-3.487-.46-5.158"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.799 19.714 5.715-3.214-5.715-3.213z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "YouTube_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 9h22v15H5z"
  })))));
};
export default SvgYouTube;